export { default } from './StaffCard'
